export const sortPartnerIds = (partnerIds: string[]): string[] => {
  return partnerIds.sort((a, b) => a.localeCompare(b))
}
